import { CreateUniversalLoanRequest, UniversalPrefillResponse } from 'app/api/loan-application/types';
import { mapToUniversalLoanApplication } from 'app/api/loan-application/universal/mappings';
import { Endpoints } from 'app/api/helpers';
import { client } from 'app/api/_client';
import { LoanOfficerDetail } from 'app/api/loan-officer';
import { getSlug } from 'app/util/headers';
import { logger } from 'app/util/logger';
import { FormType, ReferralCode } from '@lenderful/domain';
import { FieldNames } from '../../../models/fields/names';

export const mapUniversalLoanRequest = (formData, loanOfficer: LoanOfficerDetail, formName: FormType, referralCodes: ReferralCode[] = []): CreateUniversalLoanRequest => {
  const loanApplication  = mapToUniversalLoanApplication(formData, formName, referralCodes);
  return {
    id : formData[FieldNames.universalApplicationId],
    loanApplication : loanApplication,
    loanOfficerId   : loanOfficer.id,
    auditMetaData   : formData.auditMetaData,
  };
};

export const postUniversalLoanApplication = (request: CreateUniversalLoanRequest) => {
  const slug = getSlug();
  return client
    .post(Endpoints.LOANS, { ...request, slug })
    .then((response) => {
      if (response.data?.errorMessage) {
        logger.error('Error in Universal Loan API call: ', response);
        throw response;
      } else {
        return response.data;
      }
    })
    .catch((error) => {
      throw error;
    });
};

export const patchUniversalLoanApplication = (request: CreateUniversalLoanRequest) => {
  const slug = getSlug();
  return client
    .patch(Endpoints.LOANS_PATCH, { ...request, slug })
    .then((response) => {
      if (response.data?.errorMessage) {
        logger.error('Error in Patch Universal Loan API call: ', response);
        throw response;
      } else {
        return response.data;
      }
    })
    .catch((error) => {
      throw error;
    });
};

/**
 * This API call gets the prefilled data for a universal loan application
 *
 * @param {string} hash
 * @returns {Promise<UniversalPrefillResponse>}
 */
export const getPrefilledApplication = (hash: string): Promise<UniversalPrefillResponse> => {
  const slug = getSlug();
  const endpoint = `${Endpoints.LOANS}/${hash}`;
  return client
    .get<UniversalPrefillResponse>(endpoint, { params: { slug } })
    .then((response) => response.data)
    .catch((error) => {
      logger.error('ERROR: Failed to get prefilled universal loan application data', { error });
      throw error;
    });
};
